import React, { FunctionComponent } from 'react';
import {
  formatDateToDayMonth,
  getDateWithoutTimezone,
  getHoursSafeWithoutTimezone,
} from '@lt/components/utils/date';
import { Col, EndTime, StartTime, Subtitle, SubtitleRight, Wrapper } from './FlightRoute.style';
import { FlightInterchange } from '../FlightInterchange';
import { FlightRouteProps } from './FlightRoute.types';
import { FlightsLuggage } from '../FlightsLuggage';
import { FlightType } from '../FlightType';
import { getFlightTypeData } from '../FlightType/utils';

export const FlightRoute: FunctionComponent<FlightRouteProps> = ({
  parentWidth,
  className,
  data,
}: FlightRouteProps) => {
  const { direct, time, departure, arrival, origin, destination, luggage } = data;

  const parseDeparture = getDateWithoutTimezone(departure);
  const parseArrival = getDateWithoutTimezone(arrival);

  return (
    <div>
      <Wrapper parentWidth={parentWidth} className={className}>
        <Col>
          <FlightsLuggage luggage={luggage} />
          <StartTime>{getHoursSafeWithoutTimezone(parseDeparture)}</StartTime>
        </Col>
        <FlightInterchange isMobile direct={direct} time={time} />
        <Col>
          <EndTime>{getHoursSafeWithoutTimezone(parseArrival)}</EndTime>
        </Col>
      </Wrapper>

      <Wrapper parentWidth={parentWidth} className={className}>
        <Col>
          <Subtitle>{formatDateToDayMonth(departure)}</Subtitle>
          <Subtitle>{origin.name}</Subtitle>
        </Col>
        <Col>
          <SubtitleRight>{formatDateToDayMonth(parseArrival)}</SubtitleRight>
          <SubtitleRight>{destination.name}</SubtitleRight>
        </Col>
      </Wrapper>
      <Wrapper>
        <FlightType
          parentWidth={parentWidth}
          airline={data.airline}
          type={getFlightTypeData(data)}
        />
      </Wrapper>
    </div>
  );
};
